<template>
<div class="chapter">
<div class="inner_page">
<div class="aboutAuthorPage">
<a id="title13"></a>
<div class="p"><span><strong class="b">Helen Brooks</strong> lives in Northamptonshire, England, and is married with three children As she is a committed Christian, busy housewife and mother, her spare time is at a premium, but her hobbies include reading and walking her two energetic and very endearing young dogs Her long-cherished aspiration to write became a reality when, on reaching the age of forty, she finally put pen to paper and sent the result off to Harlequin</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c-br"><span><strong class="b">Helen Brooks</strong> now concentrates on writing for <br/>Harlequin Presents<sup>®</sup> <br/>Look out for T<em class="i">he</em> B<em class="i">ride’s</em> S<em class="i">ecret,</em> coming soon!</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781459253025_ata01.vue?aec21aa6